import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_selectedApi2lg32khtf3h6e as get_selectedApi,
  get_apiOverride256dzuooesqle as get_apiOverride,
} from './apiOptions.mjs';
import {
  await1xlt6i5aa076q as await_0,
  await1uwe8zvsjq69o as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { suppressConnectivityIssues31dqegaooooyg as suppressConnectivityIssues } from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch-connectivity.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { accessToken1dnygkyd4osr1 as accessToken } from '../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/auth/authInterfaces.mjs';
import { UserSessioncpstroni1zzl as UserSession } from './UserSession.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_fcmTokenr2vb68z9flza as get_fcmToken } from '../App.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { _ID___init__impl__k1lb7e2iy8126dkzvej as _ID___init__impl__k1lb7e } from '../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/models.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/LsErrorException.mjs';
import {
  ExceptionMessage21t2b5aa8xtox as ExceptionMessage,
  ExceptionToMessage30hyfnqwmqxl4 as ExceptionToMessage,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { PrimitiveClasses_getInstance13wbaztpz3e2d as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1hwzc6m64v1op as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { PersistentProperty2s7ex88zm8bn9 as PersistentProperty } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/PersistentProperty.mjs';
import { rememberSuspending14xvgr29y3z54 as rememberSuspending } from '../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { reactiveSuspendingtu9o1tcdi36e as reactiveSuspending } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContextSuspending.mjs';
import { Default_getInstance27jodt8hd1bac as Default_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { BasicListenable3uz4a8xs34a0h as BasicListenable } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_sessionToken() {
  _init_properties_currentSession_kt__oztrj1();
  return sessionToken;
}
var sessionToken;
function get_currentSession() {
  _init_properties_currentSession_kt__oztrj1();
  return currentSession;
}
var currentSession;
function get_tokenLog() {
  _init_properties_currentSession_kt__oztrj1();
  return tokenLog;
}
var tokenLog;
function get_currentSessionFailed() {
  _init_properties_currentSession_kt__oztrj1();
  return currentSessionFailed;
}
var currentSessionFailed;
function get_currentSessionNotNull() {
  _init_properties_currentSession_kt__oztrj1();
  return currentSessionNotNull;
}
var currentSessionNotNull;
var NoSuchSessionExceptionClass;
function NoSuchSessionException() {
  if (NoSuchSessionExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor() {
        return new.target.new_org_thecommunitygroupinc_cares_sdk_NoSuchSessionException_deyzch_k$();
      }
      static new_org_thecommunitygroupinc_cares_sdk_NoSuchSessionException_deyzch_k$() {
        var $this = this.new_kotlin_IllegalStateException_w47ei6_k$('Session has been terminated');
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
    }
    initMetadataForClass($, 'NoSuchSessionException', $.new_org_thecommunitygroupinc_cares_sdk_NoSuchSessionException_deyzch_k$);
    NoSuchSessionExceptionClass = $;
  }
  return NoSuchSessionExceptionClass;
}
function *deregisterToken($completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_selectedApi();
  var api = (yield* await_0(this_0, $completion)).get_api_18j9e7_k$();
  yield* suppressConnectivityIssues(deregisterToken$slambda(api), $completion);
  return Unit_instance;
}
function installLoggedOutErrors(_this__u8e3s4) {
  _init_properties_currentSession_kt__oztrj1();
  // Inline function 'com.lightningkite.kiteui.exceptions.ExceptionToMessage' call
  var tmp$ret$0 = new (installLoggedOutErrors$$inlined$ExceptionToMessage$1())(3.0);
  _this__u8e3s4.plusAssign_2usnwd_k$(tmp$ret$0);
}
function currentSession$slambda() {
  return constructCallableReference(($this$rememberSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_sessionToken();
    var tmp0_elvis_lhs = yield* await_0(this_0, $completion);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var token = tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_apiOverride();
    var tmp1_elvis_lhs = yield* await_0(this_1, $completion);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = get_selectedApi();
      tmp_0 = (yield* await_0(this_2, $completion)).get_api_18j9e7_k$();
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var api = tmp_0;
    var authApi = api.withHeaderCalculator_vab9hb_k$(accessToken(api.get_userAuth_yt6u3g_k$(), token));
    var tmp_1;
    try {
      var self_0 = yield* authApi.get_userAuth_yt6u3g_k$().getSelf_ivto1e_k$($completion);
      tmp_1 = new (UserSession())(authApi, self_0._id_1);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Exception()) {
        var e = $p;
        get_tokenLog().warn_e3mr9o_k$(['Session fetch failed', e]);
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    return tmp_1;
  }), 1);
}
function currentSession$slambda$slambda($s) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    get_tokenLog().info_59mt0k_k$(['Starting register']);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_fcmToken();
    var tmp0_safe_receiver = yield* await_0(this_0, $completion);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(tmp0_safe_receiver) > 0) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_safe_receiver = tmp;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      get_tokenLog().info_59mt0k_k$(['Registering token']);
      yield* $s.api_1.get_fcmToken_a95zde_k$().registerToken_3z6r7r_k$(_ID___init__impl__k1lb7e(tmp1_safe_receiver), $completion);
      get_tokenLog().info_59mt0k_k$(['Registered token']);
    }
    return Unit_instance;
  }), 0);
}
function currentSession$slambda_0($currentSession) {
  return constructCallableReference(($this$reactiveSuspending, $completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $currentSession;
    var tmp0_elvis_lhs = yield* await_1(this_0, $completion);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      get_tokenLog().info_59mt0k_k$(['Deregstering token logged out']);
      yield* /*#__NOINLINE__*/deregisterToken($completion);
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var s = tmp;
    yield* suppressConnectivityIssues(currentSession$slambda$slambda(s), $completion);
    return Unit_instance;
  }), 1);
}
function currentSessionNotNull$lambda($this$remember) {
  _init_properties_currentSession_kt__oztrj1();
  var result = $this$remember.invoke_r7m7el_k$(get_currentSession());
  if (result == null) {
    get_currentSessionFailed().invokeAll_w2le0p_k$();
    launch($this$remember, VOID, VOID, currentSessionNotNull$lambda$slambda());
    throw CancellationException().new_kotlin_coroutines_cancellation_CancellationException_kxgi4u_k$('No session found');
  }
  return result;
}
function currentSessionNotNull$lambda$slambda() {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* /*#__NOINLINE__*/deregisterToken($completion);
    return Unit_instance;
  }), 1);
}
function deregisterToken$slambda($api) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_fcmToken();
    var tmp0_safe_receiver = yield* await_0(this_0, $completion);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(tmp0_safe_receiver) > 0) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_safe_receiver = tmp;
    var tmp_1;
    if (tmp1_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = yield* $api.get_fcmToken_a95zde_k$().clearToken_xefvpg_k$(_ID___init__impl__k1lb7e(tmp1_safe_receiver), $completion);
    }
    return tmp_1;
  }), 0);
}
var installLoggedOutErrors$$inlined$ExceptionToMessage$1Class;
function installLoggedOutErrors$$inlined$ExceptionToMessage$1() {
  if (installLoggedOutErrors$$inlined$ExceptionToMessage$1Class === VOID) {
    class $ {
      constructor($priority) {
        this.priority_1 = $priority;
        this.forSpecificException_1 = true;
      }
      get_priority_jyafsd_k$() {
        return this.priority_1;
      }
      get_forSpecificException_cnbvel_k$() {
        return this.forSpecificException_1;
      }
      message_rracq9_k$(context, exception, metadata) {
        if (!(exception instanceof LsErrorException()))
          return null;
        var tmp$ret$0;
        $l$block: {
          if (!(exception.error_1.message_1 === 'Session has been terminated.')) {
            tmp$ret$0 = null;
            break $l$block;
          }
          get_currentSessionFailed().invokeAll_w2le0p_k$();
          tmp$ret$0 = new (ExceptionMessage())('Logged Out', 'You have been logged out, you will be redirected to the Landing page.');
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [ExceptionToMessage()]);
    installLoggedOutErrors$$inlined$ExceptionToMessage$1Class = $;
  }
  return installLoggedOutErrors$$inlined$ExceptionToMessage$1Class;
}
var properties_initialized_currentSession_kt_wdi0td;
function _init_properties_currentSession_kt__oztrj1() {
  if (!properties_initialized_currentSession_kt_wdi0td) {
    properties_initialized_currentSession_kt_wdi0td = true;
    // Inline function 'com.lightningkite.kiteui.reactive.PersistentProperty' call
    var key = 'sessionToken';
    // Inline function 'kotlinx.serialization.serializer' call
    // Inline function 'kotlinx.serialization.internal.cast' call
    var this_0 = serializer(createKType(PrimitiveClasses_getInstance().get_stringClass_bik2gy_k$(), arrayOf([]), true));
    var tmp$ret$1 = isInterface(this_0, KSerializer()) ? this_0 : THROW_CCE();
    sessionToken = PersistentProperty().new_com_lightningkite_kiteui_reactive_PersistentProperty_dblk10_k$(key, null, tmp$ret$1);
    // Inline function 'kotlin.also' call
    var this_1 = rememberSuspending(VOID, VOID, VOID, currentSession$slambda());
    var tmp = get_AppScope();
    reactiveSuspending(tmp, currentSession$slambda_0(this_1));
    currentSession = this_1;
    tokenLog = Default_getInstance().tag_ioihsw_k$('currentSession.token');
    currentSessionFailed = BasicListenable().new_com_lightningkite_reactive_core_BasicListenable_biohma_k$();
    currentSessionNotNull = remember(VOID, VOID, VOID, VOID, currentSessionNotNull$lambda);
  }
}
//region block: exports
export {
  NoSuchSessionException as NoSuchSessionException2b4vf2qlyosw1,
  get_currentSession as get_currentSession2ignzypsmrqzv,
  get_currentSessionNotNull as get_currentSessionNotNull30vuua77prq38,
  installLoggedOutErrors as installLoggedOutErrors2aolzrsu041sp,
  get_sessionToken as get_sessionTokenxwi299b0ks21,
};
//endregion

//# sourceMappingURL=currentSession.mjs.map
